import { enhancedApi } from './generated/taskActivityService';

export const { useTaskActivityListQuery } = enhancedApi;
